import React from 'react';
import { useTranslation } from 'react-i18next';
import { Container, ImageWrapper, TextEmptyState, TitleContainer } from './styles';

const EmptyState = ({ image, withSpacing, height, top, callback, text }) => {
  const { t } = useTranslation();

  return (
    <Container height={height}>
      <TitleContainer>{text}</TitleContainer>
      {image && <ImageWrapper image={image} data-panel='panel-estadisticas-emptyState-image' />}
      <TextEmptyState position={image} top={top} data-panel='panel-estadisticas-emptyState-text'>
        {withSpacing && <div className='spacing' />}
        <p>{t('panel.estadisticas.emptyState')}</p>
        <p>
          {t('panel.reputacion.emptyState.pre')}
          <button className='CTA' onClick={callback} type='button' data-panel='panel-estadisticas-emptyState-CTA'>
            {t('panel.reputacion.emptyState.cta')}
          </button>
          {t('panel.reputacion.emptyState.post')}
        </p>
      </TextEmptyState>
    </Container>
  );
};

export default EmptyState;
